import { Injectable, NgZone } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleRecaptchaService {
  public promise: Promise<void>;
  public grecaptcha: any;

  constructor(private loader: LoadingBarService) {
    this.grecaptcha = window['grecaptcha'];
    this.promise = new Promise((resolve, reject) => {
      this.grecaptcha.ready(function() {
        resolve();
      });
    });
  }

  public async getToken(action: tActions): Promise<string> {
    await this.promise;

    this.loader.start();
    return new Promise<string>((resolve, reject) => {
      this.grecaptcha.execute('6Lf5DJEUAAAAANtdRYPS2ky6Xw84eo-KZM9ax3-v', { action }).then((r: string) => {
        this.loader.stop();
        resolve(r);
      });
    });
  }
}

type tActions =
  | 'login'
  | 'mfa'
  | 'sudo'
  | 'recovery'
  | 'recoveryInitiate'
  | 'recoveryGetJWT'
  | 'register'
  | 'registerGetJWT'
  | 'form';
